<template>
  <div v-if="currentNotice && showModal" class="overlay-modal important-notices">
    <div class="modal-content">
      <div class="modal-header">
        <button @click="closeModal" class="button default">X 閉じる</button>
      </div>
      <div class="modal-body">
        <iframe
          :src="noticePath + `/notice/${currentNotice.id}`"
          id="notice_view"
          class="notice-frame"
          frameborder="0"
          width="100%"
          height="90%"
        ></iframe>
        <div
          @click="confirmNotice"
          :disabled="isNothingNotice"
          class="ml-30 mr-30 buttons-flex z-index-2 margin-auto"
        >
          <span class="button z-index-2 success medium flex-1">
            X 閉じる
          </span>
          <span class="button z-index-2 success medium flex-1 max-length-view">
            {{ isNothingNotice ? '全て確認済み' : '次のお知らせを表示' }}
          </span>
          <span class="button z-index-2 success medium flex-1 min-length-view">
            {{ isNothingNotice ? '確認済み' : '次を表示' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noticeApi from '@/api/notice'

export default {
  name: 'NoticeViewer',
  data () {
    return {
      showModal: true,
      notices: [],
      currentIndex: 0,
      noticePath: (typeof process.env.NOTICE_PATH === 'undefined' ? '/static/notices' : process.env.NOTICE_PATH) 
    }
  },
  computed: {
    currentNotice () {
      return this.notices[this.currentIndex] || null
    },
    isLastNotice () {
      return this.currentIndex === this.notices.length - 1
    },
    isNothingNotice () {
      return this.currentIndex < 0;
    }
  },
  mounted () {
    this.loadNotices()
  },
  methods: {
    async loadNotices () {
      try {
        const response = await noticeApi.getAll()
        this.notices = response.data.data
        this.notices.sort((a, b) => new Date(a.publish_at) - new Date(b.publish_at))
        this.currentIndex = this.findFirstUnreadNoticeIndex()
      } catch (error) {
        console.error('お知らせの読み込みに失敗しました:', error)
      }
    },
    async confirmNotice () {
      if (this.currentNotice) {
        try {
          await noticeApi.updateReadStatus(this.currentNotice.id, true)
          if (!this.isNothingNotice) {
            this.currentIndex++
          } else {
            alert('全てのお知らせを確認しました。')
          }
        } catch (error) {
          console.error('お知らせの既読状態の更新に失敗しました:', error)
        }
      }
    },
    findFirstUnreadNoticeIndex () {
      return this.notices.findIndex(notice => ( !notice.is_read && notice.important_flag ))
    },
    closeModal () {
      this.showModal = false
      document.querySelector('#notice_view').src = ''
    }
  }
}
</script>

<style scoped>
/* 既存のスタイルはそのまま */
.important-notices .button {
  font-size: 1.5em;
}
.confirm-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* スマホ用の表示制御スタイル */
.max-length-view {
  display: inline;
}
.min-length-view {
  display: none;
}

@media (max-width: 600px) {
  .important-notices .button {
    font-size: 1em;
  }

  /* スマホ用の表示制御スタイル */
  .max-length-view {
    display: none;
  }
  .min-length-view {
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NoticeViewer.vue